/**
 * Resolves a user-facing message from an unknown error value.
 * Prefers a non-empty string error, then an `error.message`, otherwise the fallback.
 */
export function resolveErrorMessage(error: any, fallbackMessage: string): string {
  if (typeof error === 'string' && error) {
    return error;
  }
  if (error && error.message) {
    return error.message;
  }
  return fallbackMessage;
}
